export default "__VITE_ASSET__b2101b66__"